import Modal from "react-modal";
import Navigation from "../Navigation";
import SocailIcons from "../SocailIcons/SocailIcons";
import AppForm from "../AppForm/AppForm";
import TopButton from "../TopButton";
import AppRouter from "../AppRouter/AppRouter";

import "./Main.module.css";
import { useContext } from "react";
import { AppContext } from "../../context";

const Main = () => {

  const { isOpenModal, openModal, handleShow, isOpenApp } = useContext(AppContext)

  return (
    <main>
      <AppRouter />
      <Modal
        isOpen={isOpenModal}
        onRequestClose={openModal}
        className="mymodal"
        overlayClassName="myoverlay"
        closeTimeoutMS={500}
        ariaHideApp={false}

      >
        <Navigation />
        <SocailIcons />
      </Modal>

      <Modal
        isOpen={isOpenApp}
        onRequestClose={handleShow}
        className="mymodal"
        overlayClassName="myoverlay"
        closeTimeoutMS={500}
      >
        <AppForm handleShow={handleShow} />
      </Modal>
      {/* 
      <TopButton /> */}
    </main>
  );
};

export default Main;
